import React, { useEffect, useState } from 'react';
import { Pressable, View, Text, ScrollView, FlatList } from 'react-native';
import { View as AnimatableView } from "react-native-animatable";

import { getPluralString } from '../services/CommonUtils';
import { getUserSavedAddress } from '../services/user/UserAddressUtils';
import { UserSavedAddressSubscription } from '../services/subject-behaviour/CommonRxjsService';

import { IconView } from '../widgets/CommonWidget/Icons';
import { AddressInfoView } from '../widgets/Location/Location-Widget';
import { CloseIcon, HorizontalDivider } from '../widgets/Common-Widget';

import AppTheme from '../../AppTheme';
import Modal from 'react-native-modal';
import AppStyles from '../../AppStyles';
import TextStyle from '../../TextStyle';
import Colors from '../constants/AppColors';

const LocationSelectionBottomSheet = (props) => {

    const selectedLocation = props?.selectedLocation
    const isUserLoggedIn = props?.isUserLoggedIn ?? true
    const hideSearchocation = props?.hideSearchocation ?? false

    const showLocationModal = props?.showLocationModal

    const addAddress = props?.addAddress
    const searchLocation = props?.searchLocation

    const closeModal = props.closeModal
    const onSelectSavedLocation = props?.onSelectSavedLocation
    const getUserCurrentLocation = props?.getUserCurrentLocation

    const [userSavedLocation, updateSavedLocation] = useState([])

    const isLocationSelected = (location) => {
        return selectedLocation &&
            selectedLocation['aid'] == location['aid']
    }

    const SearchLocationView = () => {
        return <View>
            <Pressable onPress={() => {
                closeModal();
                if (searchLocation) searchLocation()
            }} style={[AppStyles.mx16, AppStyles.inputContainer, {
                marginBottom: 24, marginTop: 16
            }]}>
                <IconView icon={'search_grey.svg'} size={18} />
                <Text style={[TextStyle.text14, {
                    color: Colors.grey.text, marginLeft: 8, width: AppTheme.appWidth - 100
                }]}>Search for street address, landmark</Text>
            </Pressable>
            <Pressable style={[AppStyles.flexRow, AppStyles.mx16]}
                onPress={() => { closeModal(); getUserCurrentLocation() }}>
                <IconView icon={'gps.svg'} size={18}
                    iconStyle={{ marginLeft: 16, marginRight: 8 }} />
                <Text style={[TextStyle.text14xb, { color: Colors.primary, textAlign: 'left' }]}>
                    Use Current Location</Text>
            </Pressable>
        </View>
    }

    const AddAddressView = () => {
        return <View style={[{ marginBottom: 24 }]}>
            <View style={[AppStyles.flexRowSpaceBetween, { paddingHorizontal: 16 }]}>
                <Text style={[TextStyle.text14b, { color: Colors.grey.fillerInfo }]}>
                    Saved {getPluralString(userSavedLocation.length, 'address', 'addresses')}</Text>
                <Text onPress={() => {
                    closeModal(); addAddress()
                }} style={[TextStyle.text14xb,
                { color: Colors.primary }]}>
                    <IconView icon={'add_blue.svg'} size={10} iconStyle={{ marginRight: 4 }} />
                    Add New Address
                </Text>
            </View>
        </View>
    }

    const SavedLocationView = () => {
        return (userSavedLocation.length == 0 ?
            <Text style={[TextStyle.text14b, { color: Colors.black, paddingHorizontal: 16 }]}>
                No Saved Location</Text> :
            <AnimatableView animation="fadeIn" style={{ maxHeight: 200 }}
                duration={AppTheme.transitionDuration} delay={AppTheme.transitionDuration} >
                <FlatList keyExtractor={item => item?.aid}
                    data={userSavedLocation}
                    renderItem={({ item: location, index }) =>
                        <Pressable key={location['aid']} onPress={() => {
                            closeModal(); isLocationSelected(location) ? null :
                                onSelectSavedLocation({ ...location, isAddressCompleted: true })
                        }} style={[AppStyles.borderView, {
                            paddingHorizontal: 16, paddingVertical: 16,
                            marginHorizontal: 16, marginBottom: 16,
                            borderColor: isLocationSelected(location) ?
                                AppTheme.color.primary : AppTheme.color.grey.border,
                            backgroundColor: isLocationSelected(location) ?
                                AppTheme.color.background : AppTheme.color.white
                        }]}><AddressInfoView location={location}
                            titleColor={isLocationSelected(location) ?
                                AppTheme.color.primary : AppTheme.color.black
                            } subTitleColor={isLocationSelected(location) ?
                                AppTheme.color.black : AppTheme.color.grey.text
                            } isActive={isLocationSelected(location)} />
                        </Pressable>}
                    renderToHardwareTextureAndroid />
            </AnimatableView>)
    }

    useEffect(() => {
        if (props.isUserLoggedIn) {
            UserSavedAddressSubscription.getSavedAddress().subscribe((addressData) => {
                if (addressData['hasFetched']) {
                    updateSavedLocation(addressData['addressList'] ?? [])
                } else getUserSavedAddress()
            })
        }
    }, [])

    return <Modal key={'location bottom sheet'}
        isVisible={showLocationModal} hasBackdrop={true}
        deviceHeight={AppTheme.modalHeight}
        backdropOpacity={AppTheme.modalBackdropOpacity}
        animationOutTiming={AppTheme.modalAnimationDuration}
        style={[AppStyles.alignCenter, { marginBottom: 0 }]}
        onBackdropPress={() => closeModal()}>
        <View style={[AppStyles.bottomFix, {
            backgroundColor: AppTheme.color.white, paddingVertical: 16,
            borderTopLeftRadius: 12, borderTopRightRadius: 12
        }]}>

            <View style={[AppStyles.flexRowSpaceBetween, AppStyles.mx16, { marginBottom: 8 }]}>
                <Text style={TextStyle.text20xb}>Select Location</Text>
                <CloseIcon action={() => closeModal()} />
            </View>

            {hideSearchocation && <HorizontalDivider
                width={AppTheme.appWidth} marginVertical={24} />}

            <ScrollView style={{ maxHeight: userSavedLocation.length ? 375 : 204 }}>

                {hideSearchocation ? null : <SearchLocationView />}

                {hideSearchocation ? null : <HorizontalDivider
                    width={AppTheme.appWidth} marginVertical={24} />}

                <AddAddressView />

                {isUserLoggedIn && <SavedLocationView />}

            </ScrollView>

        </View>
    </Modal>
}

export default LocationSelectionBottomSheet